import { Component, inject } from '@angular/core';
import { MatProgressBar } from '@angular/material/progress-bar';
import { RouterOutlet } from '@angular/router';
import { connectState } from '@examdojo/angular/util';
import { DebuggingWindowComponent } from '@examdojo/core/debugging';
import { FeatureFlagDirective, FeatureFlagService } from '@examdojo/core/feature-flag';
import { ExamDojoFeatureFlag, ExamdojoFeatureFlags } from '@examdojo/models/feature-flag';
import { LoaderComponent } from '@examdojo/ui/loader';
import { RoutingLoadingService } from '@examdojo/ui/loading';
import { IonApp } from '@ionic/angular/standalone';
import { translateSignal } from '@jsverse/transloco';
import { register as registerSwiper } from 'swiper/element/bundle';
import { APP_EFFECTS } from './effects';
import { IntercomService } from './intercom/intercom.service';

registerSwiper();

@Component({
  selector: 'dojo-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
  imports: [IonApp, RouterOutlet, DebuggingWindowComponent, FeatureFlagDirective, LoaderComponent, MatProgressBar],
  providers: [...APP_EFFECTS],
})
export class AppComponent {
  constructor(private readonly routingLoadingService: RoutingLoadingService) {}

  private readonly instantiatedServices = [
    ...APP_EFFECTS,
    IntercomService,
    FeatureFlagService<ExamdojoFeatureFlags>,
  ].map((service) => inject(service));

  /**
   * By design, Transloco will only load the scopes when they are actually used, not when being provided.
   * This comes with the limitation of not being able to translate programmatically when the scope is not loaded, typically in toasts.
   * Do not remove.
   * @see https://github.com/jsverse/transloco/issues/820
   */
  protected readonly preloadExamdojoTranslationsLoading = translateSignal('');

  protected readonly ExamDojoFeatureFlag = ExamDojoFeatureFlag;

  readonly state = connectState({
    showFullScreenLoader: this.routingLoadingService.showFullScreenLoader$,
    showLoadingBar: this.routingLoadingService.showLoadingBar$,
  });
}
